export { default } from './Outdoor';